exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".update-password .basepage-container{min-height:40vh}.toggle-switch{position:relative;display:inline-block;width:50px;height:28px;flex-shrink:0}.toggle-switch input{opacity:0;width:0;height:0}.toggle-slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#dc3545;transition:.3s;border-radius:34px;box-shadow:inset 0 1px 3px rgba(0,0,0,.2)}.toggle-slider:before{position:absolute;content:\"\";height:20px;width:20px;left:4px;bottom:4px;background-color:#fff;transition:.3s;border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,.3)}.toggle-switch input:checked+.toggle-slider{background-color:#05c46b}.toggle-switch input:checked+.toggle-slider:before{transform:translateX(22px)}.toggle-switch input:disabled+.toggle-slider{opacity:.6;cursor:not-allowed}.toggle-switch:hover .toggle-slider{box-shadow:0 0 0 3px rgba(5,196,107,.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Profile/profile.scss
// module id = 1711
// module chunks = 0